import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    request() { /* do nothing */ },
    failure() { /* do nothing */ },
    close() { /* do nothing */ },
    success() { /* do nothing */ },
    send() { /* do nothing */ },
  },
});

export const socket = socketSlice.actions;
export default socketSlice.reducer;
